import { z } from "zod"

export const DocumentCategorySchema = z.object({
  id: z.number(),
  name: z.string(),
  root: z.number(),
  order: z.number(),
  hierarchy_name: z.string().optional().default(''),
})

export const DocumentCategoryFormSchema = z.object({
  name: z.string().min(1, "documentCategories.validation.nameRequired"),
  root: z.number().nullable().default(null),
})

export type DocumentCategory = z.infer<typeof DocumentCategorySchema>
export type DocumentCategoryFormValues = z.infer<typeof DocumentCategoryFormSchema>

export interface TreeNode {
  id: number
  name: string
  root: number
  order: number
  hierarchy_name?: string
  depth: number
  children: TreeNode[]
}

export interface FlatItem {
  id: number
  name: string
  root: number
  order: number
  hierarchy_name?: string
  depth: number
  hasChildren: boolean
}

export type DropPosition = 'before' | 'after' | 'inside'
